(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product--default"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function chatBoxPosition() {
      var stickyCart = document.querySelector('.sticky-atc-bar');
      if (stickyCart) {
        var heightStickyCart = stickyCart.offsetHeight + 10;
        document.querySelector('body').style.setProperty('--bottom', heightStickyCart + 'px');
      }
    }
    chatBoxPosition();
    window.addEventListener(
      'resize',
      function () {
        chatBoxPosition();
      },
      true
    );
  });

  } catch(e) { console.error(e); }
})();
})();
